import React, { createContext, useContext, useState, useEffect } from 'react';
import { getMe } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user,    setUser]    = useState(null);
  const [loading, setLoading] = useState(true);

  // ── On app load, check if token exists ──────────────────
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      getMe()
        .then(res => setUser(res.data))
        .catch(() => {
          localStorage.removeItem('token');
          setUser(null);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  // ── Login ────────────────────────────────────────────────
  const loginUser = (token, userData) => {
    localStorage.setItem('token', token);
    setUser(userData);
  };

  // ── Logout ───────────────────────────────────────────────
  const logoutUser = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  // ── Role Helpers ─────────────────────────────────────────
  // role_id: 1 = super_user, 2 = admin, 3 = Teacher
  const isSuperAdmin     = user?.role_id === 1;
  const isAdmin          = user?.role_id === 2;
  const isTeacher        = user?.role_id === 3;
  const isAdminOrAbove   = user?.role_id === 1 || user?.role_id === 2;

  return (
    <AuthContext.Provider value={{
      user,
      loading,
      loginUser,
      logoutUser,
      isSuperAdmin,
      isAdmin,
      isTeacher,
      isAdminOrAbove,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

// ── Custom hook ──────────────────────────────────────────
export function useAuth() {
  return useContext(AuthContext);
}